import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { PkService } from '../pk.service';
import { IPKRoleMatch } from '../pk';
import { BehaviorSubject, Subject } from 'rxjs';
import { ILightWeightObject } from '../../../shared/models';
import { FiSnackBarService } from '../../../shared/fi-snackbar/snack-bar.service';
import { AppTextService } from '../../../shared/app-text';
import { FiCustomerDataService } from '../../../shared/fi-shared-services/fi-customer-data.service';
import { SaveChangesWarningService } from '../../../shared/fi-shared-services/save-changes-warning.service';

@Component({
    selector: 'pk-roles-matching',
    templateUrl: './pk-roles-matching.component.html',
    styleUrls: ['./pk-roles-matching.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'pk-roles-matching' },
    standalone: false,
})
export class PkRolesMatchingComponent implements OnInit, OnDestroy {
    @Input() roles: ILightWeightObject[];
    @Input() existingRoleMatches: IPKRoleMatch[];

    pkRoleMatches$ = new BehaviorSubject<IPKRoleMatch[]>([]);
    private hasChanges = false;

    constructor(
        private pkService: PkService,
        private fiSnackBarService: FiSnackBarService,
        private appTextService: AppTextService,
        private customerDataService: FiCustomerDataService,
        private saveChangesWarningService: SaveChangesWarningService,
    ) {}

    ngOnInit(): void {
        this.pkRoleMatches$.next(this.existingRoleMatches);

        this.saveChangesWarningService.start(() => this.hasChanges);
    }

    importRoles() {
        this.pkService.getRoleMatches().then((result) => {
            this.pkRoleMatches$.next(result);
            this.hasChanges = false;
        });
    }

    onRoleIdChanged(pkRole: IPKRoleMatch) {
        this.hasChanges = true;
    }

    getDisplayName(): string {
        return this.customerDataService.customerData.DisplayName;
    }

    onExcludeFromImportChanged(pkRoleMatch: IPKRoleMatch) {
        if (pkRoleMatch.ExcludeFromImport) {
            pkRoleMatch.RoleId = undefined;
        }
        this.hasChanges = true;
    }

    saveRoleMatches() {
        this.pkService.saveRoleMatches(this.pkRoleMatches$.value).then(() => {
            this.existingRoleMatches = this.pkRoleMatches$.value;
            this.showSnackBar();
            this.hasChanges = false;
        });
    }

    private showSnackBar(): void {
        this.fiSnackBarService.showSnackbar({
            textMessage: this.appTextService.get('pk.snackbar_matching_roles'),
            buttonText: this.appTextService.get('common.dismiss'),
        });
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
